import React from 'react';
import { useLanguage, LANGUAGES } from '../contexts/LanguageContext';

/**
 * Big flag-led language picker for the pre-auth screens.
 *
 * A first-time visitor who reads neither English nor Portuguese must be able to
 * switch language before they hit a wall of text they can't read — so this is
 * deliberately large, icon-led and above the fold, not a small header control.
 */
export default function LanguagePickerLarge({ className = '', tone = 'default' }) {
  const { language, setLanguage } = useLanguage();

  // The landing page paints its own dark palette regardless of the app theme,
  // so the themed border tokens would be invisible there.
  const inactive =
    tone === 'dark'
      ? 'border-white/20 text-white/80 hover:border-white/40'
      : 'border-border/50 hover:border-border opacity-80';

  return (
    <div
      className={`flex items-center justify-center gap-3 ${className}`}
      data-testid="prelogin-language-picker"
    >
      {LANGUAGES.map((lang) => {
        const active = language === lang.code;
        return (
          <button
            key={lang.code}
            type="button"
            onClick={() => setLanguage(lang.code)}
            aria-label={lang.name}
            aria-pressed={active}
            data-testid={`prelogin-lang-${lang.code}`}
            className={`flex items-center gap-2 min-h-[48px] px-4 rounded-xl border-2 transition-all ${
              active ? 'border-primary bg-primary/10' : inactive
            }`}
          >
            <img src={lang.flagImg} alt="" className="w-7 h-5 object-cover rounded-sm" />
            <span className="text-sm font-medium">{lang.code.toUpperCase()}</span>
          </button>
        );
      })}
    </div>
  );
}
